// @ts-strict-ignore
import { useGetChannelQuery } from 'hooks/queries/useGetChannelQuery'
import { useGetPaymentQuery } from 'hooks/queries/useGetPaymentQuery'
import { ContactCase } from 'types/contacts'
import { PaymentContextType } from 'types/payments'

interface ContactCaseSidePanelHelperProps {
  contactCase: ContactCase
  paymentContextType: PaymentContextType
}

export const useContactCaseSidePanelHelper = ({
  contactCase,
  paymentContextType,
}: ContactCaseSidePanelHelperProps) => {
  const {
    data: payment,
    isFetching: isFetchingPayment,
    isError: isErrorPayment,
  } = useGetPaymentQuery(
    contactCase?.paymentContext?.paymentExternalId,
    paymentContextType === PaymentContextType.PAYMENT_IN
  )

  const {
    data: channel,
    isFetching: isFetchingChannel,
    isError: isErrorChannel,
  } = useGetChannelQuery(
    contactCase?.paymentContext?.channelUUID,
    paymentContextType === PaymentContextType.CHANNEL_PAYMENT
  )

  const isChannelPayment = paymentContextType === PaymentContextType.CHANNEL_PAYMENT
  const isPaymentIn = paymentContextType === PaymentContextType.PAYMENT_IN
  const isDirectDeposit = paymentContextType === PaymentContextType.DEPOSIT
  const isWithdrawal = paymentContextType === PaymentContextType.WITHDRAWAL
  const isError = (isErrorPayment && isPaymentIn) || (isErrorChannel && isChannelPayment)

  return {
    isLoading: isFetchingChannel || isFetchingPayment,
    isError,
    channel,
    payment,
    isChannelPayment,
    isPaymentIn,
    isDirectDeposit,
    isWithdrawal,
  }
}
